var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 11.7119H1.25C0.560156 11.7119 0 11.169 0 10.5004C0 9.83175 0.560156 9.28882 1.25 9.28882H28.75C29.4398 9.28882 30 9.83175 30 10.5004C30 11.169 29.4398 11.7119 28.75 11.7119Z",
    fill: "#499FD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 2.42311H1.25C0.560156 2.42311 0 1.88018 0 1.21155C0 0.542927 0.560156 0 1.25 0H28.75C29.4398 0 30 0.542927 30 1.21155C30 1.88018 29.4398 2.42311 28.75 2.42311Z",
    fill: "#499FD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 21H1.25C0.560156 21 0 20.4571 0 19.7885C0 19.1198 0.560156 18.5769 1.25 18.5769H28.75C29.4398 18.5769 30 19.1198 30 19.7885C30 20.4571 29.4398 21 28.75 21Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.60846716.svg";
export { ForwardRef as ReactComponent };